import React from 'react'

import { Pressable, XStack } from '@zet/design-system'
import { M14 } from '@zet/integration-flow/components/typography'

interface FilterItem {
  key: string
  displayText: string
}

interface FilterChipsProps {
  items: FilterItem[]
  selectedItems: string[]
  onToggle: (itemKey: string) => void
}

export const FilterChips: React.FC<FilterChipsProps> = ({
  items,
  selectedItems,
  onToggle,
}) => {
  return (
    <XStack className="flex-wrap">
      {items?.map((item) => {
        const isSelected = selectedItems.includes(item.key)

        return (
          <Pressable
            key={item.key}
            className={`mb-2 mr-2 py-2 px-[14px] self-start border-[1px] rounded-full ${
              !isSelected ? '' : 'bg-primary-10'
            } ${isSelected ? 'border-[#5D00B5]' : 'border-[#22004A1F]'}`}
            onPress={() => onToggle(item.key)}
          >
            <M14 className={isSelected ? 'text-[#5D00B5]' : 'text-grays-80'}>
              {item.displayText}
            </M14>
          </Pressable>
        )
      })}
    </XStack>
  )
}
